import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

const CLAIM_URL_RE = /\/claims\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  let claimId = null;
  const m = (config.url || "").match(CLAIM_URL_RE);
  if (m) claimId = m[1];
  if (!claimId && config.data && typeof config.data === "object" && !(config.data instanceof FormData) && config.data.claim_id) {
    claimId = config.data.claim_id;
  }
  if (claimId) {
    const ct = localStorage.getItem(`claim_token_${claimId}`);
    if (ct) config.headers["X-Claim-Token"] = ct;
  }
  return config;
});

api.interceptors.response.use((res) => {
  if ((res.config.method || "").toLowerCase() === "post" && /\/claims$/.test(res.config.url || "") && res.data?.id && res.data?.access_token) {
    localStorage.setItem(`claim_token_${res.data.id}`, res.data.access_token);
  }
  return res;
});

export default api;

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;
